var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-activity-table-rating-cell-container",class:{
    'unsaved-highlight': _vm.unsavedHighlight,
    'error-highlight': _vm.errorHighlight,
  },style:(_vm.styles)},[_c('div',{staticClass:"cell-content"},[_c('RatingDropdown',{attrs:{"name":_vm.selectElementName,"rating":_vm.rating,"on-change":_vm.onChange,"font-size":36,"option-font-size":18}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }